module.exports = __webpack_public_path__ + "img/Infografis_EN_17.931551c1.jpg";